import { useState } from 'react';
import { 
  Box, 
  IconButton,
  Menu, 
  MenuItem,
} from '@mui/material';
import {
  DivVideo,
  VideoLabel,
  BoxFormat,
  Img,
  TypographyTitle,
  TypographySubTitle,
  TypographyMenuMoreFormats,
  TypographyVideo,
  DivTitle
} from './styles';
import { useQuery } from 'react-query';
import { listFormats } from '../../../services/studio';
import iconCanva from '../../../assets/icons/iconLogoCanva.png';
import iconLogoDatasales from '../../../assets/icons/iconLogoDatasales.png';
import formatPost from '../../../assets/studio/formatPost.png';
import formatPostVideo from '../../../assets/studio/formatPostVideo.png';
import formatStory from '../../../assets/studio/formatStory.png';
import formatStoryVideo from '../../../assets/studio/formatStoryVideo.png';
import formatEncarte from '../../../assets/studio/formatEncarte.png';
import formatCartazRetrato from '../../../assets/studio/formatCartazRetrato.png';
import formatCartazPaisagem from '../../../assets/studio/formatCartazPaisagem.png';
import formatEtiquetas from '../../../assets/studio/formatEtiquetas.png';
import formatModelosProntos from '../../../assets/studio/formatModelosProntos.png';
import formatPersonalizado from '../../../assets/studio/formatPersonalizado.png';
import formatImportar from '../../../assets/studio/formatImportar.png';
import formatTvIndoor from '../../../assets/studio/formatTvIndoor.png';
import formatCanvaLogotipo from '../../../assets/studio/formatCanvaLogotipo.png';
import formatCanvaCardapio from '../../../assets/studio/formatCanvaCardapio.png';
import formatCanvaCartaoReceitas from '../../../assets/studio/formatCanvaCartaoReceitas.png';
import formatCanvaCartaoVisitas from '../../../assets/studio/formatCanvaCartaoVisitas.png';
import formatCanvaBilhete from '../../../assets/studio/formatCanvaBilhete.png';


type FormartType = {
  companyId: number;
  createdAt: string;
  height: number;
  id: number;
  name: string;
  updatedAt: string;
  width: number;
}

export const NewStudio = () => {
  const [myFormats,setMyFormats] = useState<Array<FormartType>>([]);
  const [anchorElMoreFormats,setAnchorElMoreFormats] = useState<null | HTMLElement>(null);
  const openMoreFormats = Boolean(anchorElMoreFormats);
  const MY_COMPANY_ID = 396;
  
  const handleClickMoreFormats = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElMoreFormats(event.currentTarget);
  }
  const handleCloseMoreFormats = () => {
    setAnchorElMoreFormats(null);
  }

  useQuery({
    queryKey: ['formatsQuery'],
    queryFn: listFormats,
    onSuccess(data) {
      const myFormats = data.filter((format: FormartType) => format.companyId === MY_COMPANY_ID);
      setMyFormats(myFormats);
    },
  })

  return (
    <>
      <Box>
      <Box sx={{alignItem: 'center'}}>   
          <DivTitle>
            <TypographyTitle
              sx={{
                '&.MuiTypography-root':{
                  fontSize: '1.25rem',
                  lineHeight: '2rem'
                }
              }}
            >
              Estúdio de criação Datasales  
            </TypographyTitle>
            <Img src={iconLogoDatasales} 
              style={{
                width: '20px',
                height: '20px',
                marginLeft: '8px'
              }}/>  
          </DivTitle>
          <TypographySubTitle marginBottom={'2rem'}>
            Crie artes de maneira prática com o estudio da Datasales
          </TypographySubTitle>

          <Box 
            sx={{ 
              display: 'flex', 
              flexWrap: 'wrap',
            }}
          >
            <BoxFormat>
              <Img src={formatPost} />
              <TypographyTitle>Post</TypographyTitle>
              <TypographySubTitle>Formato quadrado, ideal para Redes Sociais</TypographySubTitle>
            </BoxFormat>
            
            <BoxFormat>
              <Img src={formatPostVideo} />
              <DivVideo>
                <TypographyTitle>Post</TypographyTitle>
                <VideoLabel><TypographyVideo>Vídeo</TypographyVideo></VideoLabel>
              </DivVideo>
              <TypographySubTitle>
                Vídeo em formato em quadrado
              </TypographySubTitle>
            </BoxFormat>
            
            <BoxFormat>
              <Img src={formatStory} />
              <TypographyTitle>Story</TypographyTitle>
              <TypographySubTitle>
                Formato ideal para stories e status
              </TypographySubTitle>
            </BoxFormat>
            
            <BoxFormat>
              <Img src={formatStoryVideo} />
              <DivVideo>
                <TypographyTitle>Story</TypographyTitle>
                <VideoLabel><TypographyVideo>Vídeo</TypographyVideo></VideoLabel>
              </DivVideo>
              <TypographySubTitle>
                Vídeo no formato para stories e status
              </TypographySubTitle>
            </BoxFormat>
          
            <BoxFormat>
              <Img src={formatEncarte} />
              <TypographyTitle>Encarte</TypographyTitle>
              <TypographySubTitle>Ideal para criar artes com até 30 produtos</TypographySubTitle>
            </BoxFormat>
            
            <BoxFormat>
              <Img src={formatCartazRetrato} />
              <TypographyTitle>Cartaz retrato</TypographyTitle>
              <TypographySubTitle>
                Encartes retrato, ideal para impressão
              </TypographySubTitle>
            </BoxFormat>
            
            <BoxFormat>
              <Img src={formatCartazPaisagem} />
              <TypographyTitle>Cartaz paisagem</TypographyTitle>
              <TypographySubTitle>
                Encarte deitado, ideal para impressão
              </TypographySubTitle>
            </BoxFormat>
            
            <BoxFormat>
              <Img src={formatTvIndoor} />
              <TypographyTitle>Tv (indoor)</TypographyTitle>
              <TypographySubTitle>Faça ofertas nas TVs do seu estabelecimento</TypographySubTitle>
            </BoxFormat>
            
            <BoxFormat>
              <Img src={formatEtiquetas} />
              <TypographyTitle>Etiqueta</TypographyTitle>
              <TypographySubTitle>Ideal para impressão A4</TypographySubTitle>
            </BoxFormat>
            
            <BoxFormat>
              <Img src={formatModelosProntos} />
              <TypographyTitle>Modelos Prontos</TypographyTitle>
              <TypographySubTitle>Adicione seus produtos a imagens prontas</TypographySubTitle>
            </BoxFormat>

            <BoxFormat>
              <Img src={formatImportar} />
              <TypographyTitle>Importar</TypographyTitle>
              <TypographySubTitle>Faça upload de uma imagem</TypographySubTitle>
            </BoxFormat>

            <BoxFormat>
              <Img src={formatPersonalizado} />
              <TypographyTitle>Personalizado</TypographyTitle>
              <TypographySubTitle>Crie um modelo em branco</TypographySubTitle>
            </BoxFormat>
          </Box>
        
          <Box>
            {parseInt(localStorage.getItem('companyId') || '') === 2996 && (
              <BoxFormat>
                <Img src="https://datasalesio-imagens.s3.amazonaws.com/tmp-jhgs/format-page/tv-indoor.png" />
                <TypographyTitle>Banner 9x3m</TypographyTitle>
                <TypographySubTitle>Formato de banner personalizado</TypographySubTitle>
              </BoxFormat>
            )}
            
            {parseInt(localStorage.getItem('companyId') || '') === 1115 && (
              <BoxFormat>
                <Img src="https://datasalesio-imagens.s3.amazonaws.com/tmp-jhgs/format-page/encarte.png" />
                <TypographyTitle>Encarte - PET CAMP</TypographyTitle>
                <TypographySubTitle>Formato de encarte personalizado</TypographySubTitle>
              </BoxFormat>
            )}
            
            {parseInt(localStorage.getItem('companyId') || '') === 1115 && (
              <BoxFormat>
                <Img src="https://datasalesio-imagens.s3.amazonaws.com/tmp-jhgs/format-page/encarte.png" />
                <TypographyTitle>Encarte Aberto - PET CAMP</TypographyTitle>
                <TypographySubTitle>Formato de encarte personalizado</TypographySubTitle>
              </BoxFormat>
            )}
    
          </Box>
        </Box>
      </Box>
      
      <Box 
        sx={{
          display: 'flex',
          flexDirection: 'column',
          background: '#FFFFFF',
          marginLeft: '-2rem',
          marginRight: '-2rem',
          marginBottom: '-2rem',
          marginTop: '2rem',
          padding: '2rem'
        }}
      >
          <DivTitle>
            <TypographyTitle 
              sx={{
                '&.MuiTypography-root':{
                  fontSize: '1.25rem',
                  lineHeight: '2rem'
                }}}
            >
              Estúdio Canva  
            </TypographyTitle>
            
            <Img src={iconCanva} 
              style={{
                width: '24px',
                height: '24px',
                marginLeft: '8px'
              }}
            />  
          </DivTitle>
          
          <TypographySubTitle marginBottom={'2rem'}>
            Use o editor do Canva para criar suas artes
          </TypographySubTitle>
          
          <Box 
            sx={{ 
              display: 'flex', 
              flexWrap: 'wrap',
            }}
          >
            <BoxFormat>
              <Img src={formatCanvaLogotipo} />
              <TypographyTitle>Logotipo</TypographyTitle>
              <TypographySubTitle>Crie o logo da sua loja</TypographySubTitle>
            </BoxFormat>
            
            <BoxFormat>
              <Img src={formatCanvaCardapio} />
              <TypographyTitle>Cardápio</TypographyTitle>
              <TypographySubTitle>
                Estilize o cardápio do seu estabelecimento
              </TypographySubTitle>
            </BoxFormat>
            
            <BoxFormat>
              <Img src={formatCanvaCartaoReceitas} />
              <TypographyTitle>Cartão de receitas</TypographyTitle>
              <TypographySubTitle>
                Compartilhe receitas com seus clientes
              </TypographySubTitle>
            </BoxFormat>
            
            <BoxFormat>
              <Img src={formatCanvaCartaoVisitas} />
                <TypographyTitle>Cartão de visitas</TypographyTitle>
              <TypographySubTitle>
                Faça seu cliente lembrar de você
              </TypographySubTitle>
            </BoxFormat>
          
            <BoxFormat>
              <Img src={formatCanvaBilhete} />
              <TypographyTitle>Bilhete</TypographyTitle>
              <TypographySubTitle>Dê dicas e avisos aos seus clientes</TypographySubTitle>
            </BoxFormat>
            
            {Boolean(myFormats.length) &&(
              <BoxFormat>
                <IconButton
                  onClick={handleClickMoreFormats}
                  aria-controls={openMoreFormats ? 'account-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={openMoreFormats ? 'true' : undefined}
                  sx={{
                    height: '180px',
                    width: '180px',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: '#F2F3F5',
                  }}
                >
                  <Img
                    style={{
                      width: '3.5rem',
                      height: '3.5rem'
                    }}  
                    src="https://datasalesio-imagens.s3.amazonaws.com/tmp-jhgs/icons/iconMaisFormatos.png" />
                </IconButton>
                <Menu
                  anchorEl={anchorElMoreFormats}
                  id={'more-formats'}
                  open={openMoreFormats}
                  onClose={handleCloseMoreFormats}
                  onClick={handleCloseMoreFormats}
                  transformOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                  anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
                  PaperProps={{
                    sx: {
                      filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                      width:  '210px',
                    }}}
                >
                  {myFormats.map((format, index) => (
                    <MenuItem
                      key={index}
                      style={{
                        height: '2.5rem'
                      }}
                    > 
                      <TypographyMenuMoreFormats>{format.name}</TypographyMenuMoreFormats>
                    </MenuItem>
                  ))}
                </Menu>
                <TypographyTitle>Todos os formatos</TypographyTitle>
                <TypographySubTitle>Escolha o formato que mais te atende</TypographySubTitle>
              </BoxFormat>
            )}
          </Box>
      </Box>
    </>
  );
};

